import React from "react";
import { func, node, object, shape } from "prop-types";

let warn = action => {
	// eslint-disable-next-line no-console
	console.warn(action, "\nThe localization context is absent. Use LocaleProvider");
	warn = () => {}; // no more messages
};

const FAKE_TRANSLATOR_API = {
	i18: {
		t: key => {
			warn(`Cannot get text for key "${key}"`);
			return key;
		},
		getFixedT: () => {
			warn("Cannot bind namespace or language.");
			return key => key;
		},
	},
	subscribe: () => {
		warn("Cannot subscribe on localization events.");
	},
	setLanguage: () => {
		warn("Cannot set language.");
		return Promise.resolve();
	},
	release: () => {
		warn("Cannot unsubsribe from localization events.");
	},
};

const i18Context = React.createContext(FAKE_TRANSLATOR_API);

export const I18Provider = ({ translator, children }) => (
	<i18Context.Provider value={translator}>{children}</i18Context.Provider>
);

I18Provider.propTypes = {
	translator: shape({
		setLanguage: func.isRequired,
		subscribe: func.isRequired,
		i18: object, // eslint-disable-line react/forbid-prop-types
	}).isRequired,
	children: node,
};

export default i18Context;
